import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Applicant-show controller connected");
    
    // Fix for any existing scroll issues on page load
    this.forceScrollingEnabled();
    
    this.setupSmoothScrollingAnchors();
    
    // Listen for custom event from video preview controller
    document.addEventListener('video-modal-opened', this.handleVideoModalOpened.bind(this));
    document.addEventListener('video-modal-closed', this.handleVideoModalClosed.bind(this));
    
    // Add keyboard event listener for Escape key
    document.addEventListener('keyup', this.handleKeyup.bind(this));
    
    // Add a direct click handler to all video enlarge buttons to catch them
    this.attachVideoButtonHandlers();
    
    // Save initial state
    this.scrollingEnabled = true;
    this.modalOpen = false;
    
    // Set up a regular check for scroll issues
    this.scrollCheckInterval = setInterval(() => this.checkScrolling(), 1000);
  }
  
  disconnect() {
    // Clean up event listeners
    document.removeEventListener('video-modal-opened', this.handleVideoModalOpened.bind(this));
    document.removeEventListener('video-modal-closed', this.handleVideoModalClosed.bind(this));
    document.removeEventListener('keyup', this.handleKeyup.bind(this));
    
    // Clear interval
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
    }
  }
  
  attachVideoButtonHandlers() {
    // Find all video enlarge buttons on the page
    const buttons = document.querySelectorAll('.video-enlarge-btn');
    console.log(`Found ${buttons.length} video enlarge buttons`);
    
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        console.log("Video button clicked - will check scroll state after delay");
        
        // Schedule a delayed scroll check after the modal opens
        setTimeout(() => this.forceScrollingEnabled(), 500);
      });
    });
  }
  
  // Periodically check if scrolling is disabled and fix it
  checkScrolling() {
    const computedStyle = window.getComputedStyle(document.body);
    
    // Only log if there's an issue
    if (computedStyle.overflow === 'hidden' && !this.modalOpen) {
      console.log("Periodic check: Found scroll issue - fixing");
      this.forceScrollingEnabled();
    }
  }
  
  // Force scrolling to work regardless of state
  forceScrollingEnabled() {
    console.log("Force enabling scrolling");
    document.body.style.overflow = 'auto';
    document.body.style.paddingRight = '';
  }
  
  handleKeyup(event) {
    // Check if Escape key was pressed and a modal was open
    if (event.key === 'Escape' && this.modalOpen) {
      console.log("Escape key pressed while modal was open, ensuring scrolling is re-enabled");
      this.ensureScrollingEnabled();
    }
  }
  
  handleVideoModalOpened(event) {
    console.log("Video modal opened, disabling smooth scrolling");
    this.scrollingEnabled = false;
    this.modalOpen = true;
  }
  
  handleVideoModalClosed(event) {
    console.log("Video modal closed, re-enabling smooth scrolling");
    this.ensureScrollingEnabled();
  }
  
  ensureScrollingEnabled() {
    console.log("ensureScrollingEnabled called - Current body state:", {
      overflow: document.body.style.overflow || 'not set',
      paddingRight: document.body.style.paddingRight || 'not set',
      classes: document.body.className
    });
    
    // Re-enable scrolling functionality
    this.scrollingEnabled = true;
    this.modalOpen = false;
    
    // Use our simpler, more direct approach
    this.forceScrollingEnabled();
    
    // Remove any classes that might be blocking scrolling
    document.body.classList.remove('modal-open');
    
    // Set up additional checks to ensure scrolling is enabled after delays
    // Sometimes Bootstrap's handlers run after our code
    setTimeout(() => this.forceScrollingEnabled(), 100);
    setTimeout(() => this.forceScrollingEnabled(), 300);
    setTimeout(() => this.forceScrollingEnabled(), 1000);
    
    console.log("After fixing - Current body state:", {
      overflow: document.body.style.overflow || 'not set',
      paddingRight: document.body.style.paddingRight || 'not set',
      classes: document.body.className
    });
  }

  setupSmoothScrollingAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        console.log("Anchor clicked, scrollingEnabled:", this.scrollingEnabled);
        
        // Don't process scrolling if it's disabled (modal is open)
        if (!this.scrollingEnabled) {
          console.log("Scrolling currently disabled, ignoring anchor click");
          return;
        }
        
        e.preventDefault();
        const href = anchor.getAttribute('href');

        // Skip processing if href is just "#" or empty
        if (!href || href === '#') {
          console.log('Skipping anchor with empty href or "#"');
          return;
        }

        try {
          const target = document.querySelector(href);
          if (!target) {
            console.warn(`Element with selector "${href}" not found`);
            return;
          }

          const headerOffset = 165; // Adjust based on your header height
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        } catch (error) {
          console.error(`Error processing anchor with href "${href}":`, error);
        }
      });
    });
  }
}